// PROMPT 144: los colores de las marcas en la pantalla Agente WhatsApp.
// La tabla es la misma que usa el servidor (backend/agente_wa/canal.py, COLORES_MARCA) y
// sirve cuando /whatsapp/marcas todavía no trajo el color de la marca.

export const COLORES_MARCA = {
  interviajes: "#D4A017", // mostaza
  vacaciones: "#16A34A", // verde
  intertravel: "#2563EB", // azul
  excursiones_ny: "#DC2626", // rojo
};
export const COLOR_OTRAS_MARCAS = "#64748B";

// Nombre corto de cada marca para el chip de la lista: nunca se corta.
export const NOMBRES_CORTOS = {
  interviajes: "Interviajes",
  vacaciones: "Vacaciones",
  intertravel: "Intertravel",
  excursiones_ny: "Excursiones NY",
};

export const SIN_NUMERO = "Sin número visible";

const HEX = /^#[0-9a-f]{6}$/i;

export const esColorValido = (valor) => HEX.test(String(valor || "").trim());

// El color de la marca: el que se guardó en Canal (lo trae /whatsapp/marcas) o el de la tabla.
export function colorDeMarca(slug, marcas) {
  const m = (marcas || []).find((x) => x && x.slug === slug);
  if (m && esColorValido(m.wa_color)) return String(m.wa_color).trim().toUpperCase();
  return COLORES_MARCA[slug] || COLOR_OTRAS_MARCAS;
}

export function nombreCorto(slug, marcas) {
  if (NOMBRES_CORTOS[slug]) return NOMBRES_CORTOS[slug];
  const m = (marcas || []).find((x) => x && x.slug === slug);
  return (m && (m.nombre || m.remitente_nombre)) || slug || "";
}

// Cómo se llama el cliente en pantalla, en este orden: el nombre del contacto, el que se
// cargó, el usuario de WhatsApp, el teléfono y, si no hay nada, "Sin número visible".
// (El PROMPT 149 suma adelante un nombre editado por el equipo.)
export function nombreVisible(c) {
  return (c && (c.nombre_editado || c.nombre_contacto || c.nombre_cliente || c.wa_username || c.telefono)) || SIN_NUMERO;
}

// Para las iniciales del avatar: nunca el teléfono ni "Sin número visible".
export function nombreParaAvatar(c) {
  return (c && (c.nombre_editado || c.nombre_contacto || c.nombre_cliente || c.wa_username)) || "";
}

// ---------------------------------------------------------------- tonos de un color
const aRgb = (hex) => {
  const n = parseInt(hex.slice(1), 16);
  return [(n >> 16) & 255, (n >> 8) & 255, n & 255];
};
const aHex = (rgb) =>
  "#" +
  rgb
    .map((v) => Math.max(0, Math.min(255, Math.round(v))).toString(16).padStart(2, "0"))
    .join("")
    .toUpperCase();
const BLANCO = [255, 255, 255];
const OSCURO = [17, 24, 39];
// `parte` del color sobre el fondo (0.12 = el color al 12 %).
const mezclar = (rgb, fondo, parte) => rgb.map((v, i) => v * parte + fondo[i] * (1 - parte));
const luz = (rgb) => {
  const [r, g, b] = rgb.map((v) => {
    const s = v / 255;
    return s <= 0.03928 ? s / 12.92 : Math.pow((s + 0.055) / 1.055, 2.4);
  });
  return 0.2126 * r + 0.7152 * g + 0.0722 * b;
};
const contrasteRgb = (a, b) => {
  const la = luz(a);
  const lb = luz(b);
  return (Math.max(la, lb) + 0.05) / (Math.min(la, lb) + 0.05);
};

// Contraste entre dos colores #RRGGBB (de 1 a 21; 4.5 es el mínimo para leer texto).
export function contraste(hexA, hexB) {
  return contrasteRgb(aRgb(hexA), aRgb(hexB));
}

// Los tonos de una marca: `fuerte` (el color), `suave` (al 12 %), `borde` (al 40 %), `texto`
// (el color oscurecido hasta tener contraste 4.5:1 sobre blanco y sobre `suave`: el mostaza
// claro no se lee como texto) y `sobreFuerte` (blanco u oscuro, el que mejor se lee encima).
export function tonos(hex) {
  const base = esColorValido(hex) ? String(hex).trim().toUpperCase() : COLOR_OTRAS_MARCAS;
  const rgb = aRgb(base);
  const suave = mezclar(rgb, BLANCO, 0.12);
  const borde = mezclar(rgb, BLANCO, 0.4);
  let texto = rgb;
  for (let i = 0; i < 80 && (contrasteRgb(texto, BLANCO) < 4.5 || contrasteRgb(texto, suave) < 4.5); i += 1) {
    texto = texto.map((v) => v * 0.95);
  }
  return {
    fuerte: aHex(rgb),
    suave: aHex(suave),
    borde: aHex(borde),
    texto: aHex(texto),
    sobreFuerte: contrasteRgb(BLANCO, rgb) >= contrasteRgb(OSCURO, rgb) ? "#FFFFFF" : aHex(OSCURO),
  };
}
